'use client';

import { FC } from 'react';
import { Container, Wrapper } from '@/features/pages/home';
import { Typography } from '@mui/material';
import { COLORS } from '@/constants';
import { HousingCard } from '@/components';
import { useTranslations } from 'next-intl';
import { GridList, SimilarHead } from './styled';
import { BgFigure } from '@/features/pages/home/components/Discounted/styled';
import discountBgFigure from '@/assets/webp/discounted-bg-form.webp';
import { IHousingObjectResponse } from '@/types';

type SimilarObjectsProps = {
  objects: IHousingObjectResponse[];
  project?: boolean;
};

export const SimilarObjects: FC<SimilarObjectsProps> = ({ objects, project }) => {
  const t = useTranslations();

  return (
    <Wrapper $bgColor="blue">
      <Container>
        <SimilarHead>
          <Typography
            fontSize={{ xs: 26, sm: 26, md: 34 }}
            lineHeight={1}
            fontWeight={700}
            color={COLORS.white}
          >
            {t(project ? 'similarObjects.projectsTitle' : 'similarObjects.title')}
          </Typography>
        </SimilarHead>
        <GridList>
          {objects.map((item, i) => (
            <HousingCard data={item} key={i} isProject={project} />
          ))}
        </GridList>
      </Container>
      <BgFigure>
        <img src={discountBgFigure.src} alt="background-decoration" />
      </BgFigure>
    </Wrapper>
  );
};
